import { TableUIProvider } from "../../contexts/TableUIContext";
import ContactForms from "./ContactForms";

export default function ContactFormsWrapper() {
    return (
        <TableUIProvider>
            <ContactForms />
        </TableUIProvider>
    );
}
